import React from 'react';

const MeetAlex = () => {
  return (
    <section data-testid="meet-alex-section" className="py-20 bg-black">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        <div className="flex flex-col md:flex-row items-center gap-10 md:gap-16">
          {/* Photo */}
          <div className="flex-shrink-0">
            <div className="w-48 h-48 md:w-56 md:h-56 rounded-full overflow-hidden border-4 border-gold/30 shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_8d44df25-0f67-4d0d-b916-c24ae1fa8d16/artifacts/ifu7svtq_IMG_1066.jpeg"
                alt="Alex - Head of Memory Making"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Text */}
          <div className="text-center md:text-left">
            <p className="text-gold text-sm font-semibold uppercase tracking-widest mb-3">
              Your personal guide
            </p>
            <h2 className="font-serif text-3xl sm:text-4xl text-white mb-2">
              Meet Alex
            </h2>
            <p className="text-white/50 text-sm mb-4 italic">Head of Memory Making</p>
            <p className="text-white/70 leading-relaxed text-lg mb-4">
              From your very first message to the moment you watch your finished film, Alex is with you the whole way. No call centres. No being passed around. Just one person who genuinely cares about getting your day right.
            </p>
            <p className="text-white/50 leading-relaxed">
              He founded Wedding Video Essex in 2015 because he believes every couple deserves a film that makes them feel it all again. Over 900 happy couples later, he still gets emotional watching the final edits.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MeetAlex;
